import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "BaseItemDialog__section flex-1"
}
const _hoisted_2 = { class: "BaseItemDialog__section-header bg-white q-mb-12" }
const _hoisted_3 = { class: "fs-15px fw-600 text-cool-gray-100 block q-mb-sm" }
const _hoisted_4 = { class: "BaseItemDialog__section-body column no-wrap" }
const _hoisted_5 = { class: "row no-wrap items-center justify-between q-px-sm" }
const _hoisted_6 = { class: "fs-13px text-cool-gray-80" }
const _hoisted_7 = { class: "row no-wrap items-center gap-xs" }
const _hoisted_8 = { class: "fs-13px text-cool-gray-100" }
const _hoisted_9 = { class: "fs-13px text-cool-gray-100" }

import translate from 'src/common/helpers/language/translate'
import { IItemView } from 'src/common/interfaces'
import translationObject from 'src/pages/Inventory/Item/ItemLibrary/translate/itemLibrary.translate'

interface IProps {
  item: IItemView
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogIngredients' },
  __name: 'BaseItemDialogIngredients',
  props: {
    item: {}
  },
  setup(__props: any) {




const { t } = translate(translationObject)

return (_ctx: any,_cache: any) => {
  const _component_k_divider = _resolveComponent("k-divider")!

  return (__props.item.ingredient_data?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('ingredients')), 1),
          _createVNode(_component_k_divider, { size: "md" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.ingredient_data, (ingredient, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "column no-wrap"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(ingredient.item_name), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(ingredient.qty), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(ingredient.unit), 1)
                ])
              ]),
              (index < __props.item.ingredient_data.length - 1)
                ? (_openBlock(), _createBlock(_component_k_divider, {
                    key: 0,
                    dotted: true,
                    color: "cool-gray-50",
                    class: "q-my-12"
                  }))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})